import { EPAPER_CATEGORY_ARE_LOADING, EPAPER_CATEGORY_HAVE_ERROR, EPAPER_CATEGORY_FETCH_DATA_SUCCESS } from '../actionType';

const initialState = {
    data: [],
    loading: true,
    error: []
  };
  
  export function EPaperCategory (state = initialState, action) {
    switch (action.type) {
        case EPAPER_CATEGORY_HAVE_ERROR:
            return {
                ...state,
                error:action.hasError,
                loading:false,
            }
    
        case EPAPER_CATEGORY_ARE_LOADING:
           return {
            ...state,
            loading:action.isLoading
        }
    
        case EPAPER_CATEGORY_FETCH_DATA_SUCCESS:
            return {
                ...state,
                data:action.epaperCategory,
                loading:false,
            }

        default:
            return state;
    }
}
